import { render } from "./TranslationExporter.vue?vue&type=template&id=2fe667db"
import script from "./TranslationExporter.vue?vue&type=script&lang=js"
export * from "./TranslationExporter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__